import { Assistant, loadAssistants } from "@genai/assistant";

export interface LoaderData {
  defaultAssistant?: Assistant | undefined;
}

export const landingPageLoader = async (): Promise<LoaderData> => {
  const assistants = await loadAssistants();
  return { defaultAssistant: assistants[0] };
};
